// SwipeHandler.js
import React from 'react';
import { useSwipeable } from 'react-swipeable';

const SwipeHandler = ({ children, onSwipedLeft, onSwipedRight }) => {
  const handlers = useSwipeable({
    onSwipedLeft: onSwipedLeft,
    onSwipedRight: onSwipedRight,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  return (
    <div {...handlers} style={{ width: '100%' }}>
      {children}
    </div>
  );
};

export default SwipeHandler;
